export default function useCurrency(){

    function convert(amount){
        
    const fomattedAmount = new Intl.NumberFormat('en-LK', {
        style: 'currency',
        currency: 'LKR',
        
    }).format(amount);

    //Removes LKR from the formatted amount
    return fomattedAmount.replace('LKR', '');
    }

    return {convert};

}